import { useSelector } from "react-redux";

export const useUserName = () => {
  const user = useSelector(state => state.user.user);
  const token = useSelector(state => state.user.token);
  return {
    firstName: user?.firstName ?? token.given_name,
    lastName: user?.lastName ?? token.family_name,    
  }
}